import React, { Component } from 'react';
import CloseLoopTable from '../../components/closedLoop/closeLoopScenarioTable'
import { getAllScenarioCloseLoop ,getNewScenarioViewInfoCloseLoop} from '../../components/UserFunctions'
//import { getAllScenarioCloseLoop , getAllScenarioGroupNames} from '../../components/UserFunctions'
import { addGroupToCart } from '../../actions/addToCartAction'
import { connect } from "react-redux";
import Cart from '../../components/closedLoop/CartComponent'
import ScenarioPopup from '../../components/closedLoop/AddScenarioPopup'
// import PropTypes from 'prop-types';
// import PaginationCloseLoopRevised from "../../components/closedLoop/PaginationCloseLoopRevised";
import Pagination from './../Pagination'
import { getScenariosFromAPI } from "../../actions/closeLoop/scenarioSelectorCloseLoop"
import AdvanceSearchModalCloseLoop from '../../components/closedLoop/AdvanceSearchModalCloseLoop'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';


class CloseLoopViewScenario extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            group_name_list: [],
            scenario_group_name: "",
            scenario_popup: false,
            offset: 0,
            tableData: [],
            orgtableData: [],
            perPage: 5000,
            currentPage: 0,
        }
        this.openPopupModal = this.openPopupModal.bind(this)
        this.onhandleChangeGroupName = this.onhandleChangeGroupName.bind(this)
        this.handleOnChange = this.handleOnChange.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
    }

    componentDidMount() {
		// const dest_url = (window.location.origin).concat('/close_loop_fetch_all_scenario')
        getAllScenarioCloseLoop(1).then(res => {
            if (res.data) {
                this.props.dispatch(getScenariosFromAPI(res))
                console.log("this.props valueee: ", this.props)
                this.setState(prevState => {
                    return {
                        data: res
                    }
                })
            } else {
                this.props.dispatch(getScenariosFromAPI([]))
            }
        })

        console.log("close loop scenario view :", this.state)

    }

    onFilterClick() {
        this.setState({
            view_filter: true
        })
    }
    onCloseFilter() {
        this.setState({
            view_filter: false
        })
    }
    onSearchClick = (scenariouuid, scenarioname, description) => {
        this.setState({
            view_filter: false,
            scenariouuid: scenariouuid,
            scenarioname: scenarioname,
            description: description,
        })
        var json_obj = { 'scenariouuid': scenariouuid, 'scenarioname': scenarioname, 'description': description }

        getNewScenarioViewInfoCloseLoop(json_obj).then(response => {
            if (response.data) {
                this.props.dispatch(getScenariosFromAPI(response))
                console.log("this.props valueee: ", this.props)
                this.setState(prevState => {
                    return {
                        data: response
                    }
                })
            } else {
                this.props.dispatch(getScenariosFromAPI([]))
            }
        })
    }

    onResetClick = () => {
        this.setState({
            scenariouuid: [],
            scenarioname: [],
            description: [],
        })
        // var json_obj = { 'scenariouuid':'','scenarioname':'','description': ''}
        getAllScenarioCloseLoop(1).then(response => {
            if (response.data) {
                this.props.dispatch(getScenariosFromAPI(response))
                console.log("this.props valueee: ", this.props)
                this.setState(prevState => {
                    return {
                        data: response
                    }
                })
            } else {
                this.props.dispatch(getScenariosFromAPI([]))
            }
        })
    }

    handlePageClik = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.loadMoreData()
        })
    }

    loadMoreData() {
        const data = this.state.orgtableData;
        const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
        this.setState({
            pageCount: Math.ceil(data.length / this.state.perPage),
            tableData: slice
        })
    }

    togglePopup() {
        this.setState({
            scenario_popup: false,
        })
    }

    openPopupModal() {
        console.log("opening popup")
        this.setState({
            scenario_popup: !this.state.scenario_popup
        })
    }

    onhandleChangeGroupName(e) {
        console.log(this.props)
        this.setState({
            scenario_group_name: e.target.value
        })
        let obj = {
            group: e.target.value,
        }
        this.props.dispatch(addGroupToCart(obj))
    }

    handleOnChange(event) {
        console.log(event.target.value)
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <Link to='/welcome'>Welcome</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href=""  >
                            <Link to='/close_loop'>Close loop</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="/close_loop_view_scenario" active >
                            Scenario Selector
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="row">
                        <div className="mt-5 mx-auto">
                            <div className="card" style={{ backgroundColor: "white" }}>
                                <div className="card">
                                    <div>
                                        <div style={{ backgroundColor: "#757AF7" }}>
                                            <div className="row">

                                                <div className="col-md-4">
                                                    <h3 className="card-header" style={{ color: "white", fontSize: "100% !important", backgroundColor: "#757AF7" }}>
                                                        Scenario Selector
                                                    </h3>
                                                </div>
                                                {/* <div className="col-md-4" style={{textAlign : "center", paddingTop : "0.7%"}}>
                                              <select id="inputState" class="form-control" value={this.state.scenario_group_name} onChange={(e) => this.onhandleChangeGroupName(e)}>
                                                  <option>Select Function</option>
                                                  <option>Highway</option>
                                                  <option>Urban</option>
                                                  <option>City</option>
                                                  <option>ACC</option>
                                                  <option>AEB</option>
                                                  <option>LKA</option>
                                                  <option>LCA</option>
                                                  <option>AES</option>
                                                  <option>ALC</option>
                                                  <option>TJA</option>
                                              </select>
                                          </div> */}
                                                <div className="col-md-8" style={{ paddingLeft: "15rem", paddingTop: "0.7%" }}>
                                                    <div style={{ textAlign: "center" }}>

                                                        <button onClick={this.openPopupModal} style={{ backgroundColor: "Transparent", outline: "None", border: "None", float: "right" }}><Cart /></button>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {/* <div className="table col-md-6 mx-auto"> */}
                                    <div className="table">
                                        <div style={{ border: "1px solid #858AFF", backgroundColor: "#757AF7" }}>
                                            <div style={{ display: "inline-block", color: "red" }}>
                                                <button type="button" className="btn" onClick={() => this.onFilterClick()} style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" }} >
                                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                                    Filter
                                                </button>
                                            </div>

                                            <div style={{ textAlign: "right", padding: "6.4px", height: "2.3rem", color: "white", backgroundColor: "#757AF7", display: "inline-block" }}>
                                                Applied Filter :
                                            </div>

                                            {(this.state.scenarioname === undefined) || (this.state.scenarioname.length <= 0 && this.state.scenariouuid.length <= 0 && this.state.description.length <= 0) ?
                                                <div style={{ display: "inline-block", backgroundColor: "#f2f2f2", width: "30rem", color: "#464646" }}>
                                                    No Filters Applied
                                                </div> :
                                                <div style={{ display: "inline-block" }}>
                                                    <div style={{ backgroundColor: "#f2f2f2", width: "30rem", height: "1.8rem", color: "red", display: "inline-block" }}>
                                                        {this.state.scenariouuid} {this.state.scenarioname} {this.state.description}
                                                    </div>
                                                    <td style={{ display: "inline-block", height: "2rem", padding: "0px" }}><button style={{ height: "2rem", padding: "5px" }} type="button" onClick={this.onResetClick} ><i class="fa fa-undo"></i></button></td>
                                                </div>
                                            }
                                        </div>
                                        <CloseLoopTable data={this.props.testData} selected={this.state.scenario_group_name} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.scenario_popup ? <ScenarioPopup closePopup={this.togglePopup.bind(this)} useHistory={this.props} /> : undefined}
                    {this.state.view_filter ? <AdvanceSearchModalCloseLoop closeSearchModal={this.onCloseFilter.bind(this)} onSearchClick={this.onSearchClick} /> : ""}

                    <div>
                        {this.props.testData.length > 0 ?
                            <Pagination
                                currentPage={this.props.currentPage}
                                pages={this.props.pages}
                                getApiInfo={getAllScenarioCloseLoop}
                                action={getScenariosFromAPI}
                            />
                            : undefined}
                    </div>
                </div>
            </div>

        )
    }
}
// CloseLoopViewScenario.propTypes={
// dispatch:PropTypes.string,
// //items:PropTypes.string,
// }
// CloseLoopViewScenario.defaultProps= {
// dispatch:[],
// //items:[],
// }

const mapStateToProps = (state) => {
    return {
        group: state.close_loop_cart.group,
        testData: state.scenarioSelectorCloseLoop.testData,
        currentPage: state.scenarioSelectorCloseLoop.currentPage,
        pages: state.scenarioSelectorCloseLoop.pages
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

export default connect(mapStateToProps)(CloseLoopViewScenario)
